export default "__VITE_ASSET__ee88fa40__"